export default __webpack_public_path__ + "static/media/causes.bfcc3d99.svg";